import {GeoJsonLayer} from '@deck.gl/layers'
import {ColorMapboxToKepler, GetPropert} from '../../../explorer/components/common'
import {id} from 'date-fns/locale'

const rendaStyle = {
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'renda_mensal_domiciliar']],
    0,
    '#FF6666',
    1000,
    '#FFB266',
    2500,
    '#FFFF66',
    5000,
    '#B2FF66',
    7500,
    '#66ff66',
    9000,
    '#66ffff',
    15000,
    '#66b2ff',
    20000,
    '#6666ff',
  ],
  'fill-opacity': 0.8,
}

const precoVendaStyle = {
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'preco_m2']],
    2000,
    '#FF3333',
    4000,
    '#FF3333',
    6000,
    '#FF9933',
    8000,
    '#FFFF33',
    10000,
    '#99FF33',
    12000,
    '#33FF33',
    14000,
    '#33FF99',
    16000,
    '#33FFFF',
    18000,
    '#3399FF',
  ],
  'circle-radius': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'quartos']],
    2,
    3,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
  ],
  'circle-opacity': 1,
}

const trilhosTrajetosStyle = {
  'line-color': ['get', 'cor'],
  'line-width': 7,
  'fill-opacity': 1,
}

const trilhosEstacoesStyle = {
  'fill-color': [
    'match',
    ['get', 'linha'],
    'LINHA 10 - TURQUESA',
    '#007282',
    'LINHA 11 - CORAL',
    '#F78473',
    'LINHA 12 - SAFIRA',
    '#4D78AE',
    'LINHA 13 - JADE',
    '#00826B',
    'LINHA 15 - PRATA',
    '#B8B9B8',
    'LINHA 16 - VIOLETA',
    '#7C007C',
    'LINHA 17 - OURO',
    '#E2AE51',
    'LINHA 19 - CELESTE',
    '#75B7C4',
    'LINHA 1 - AZUL',
    '#6394F7',
    'LINHA 20 - ROSA',
    '#AE4071',
    'LINHA 22 - MARROM',
    '#4C2723',
    'LINHA 2 - VERDE',
    '#7AC74B',
    'LINHA 3 - VERMELHA',
    '#AC2937',
    'LINHA 4 - AMARELA',
    '#E0BE42',
    'LINHA 5 - LILÁS',
    '#867896',
    'LINHA 6 - LARANJA',
    '#E17D3F',
    'LINHA 7 - RUBI',
    '#A5423D',
    'LINHA 8 - DIAMANTE',
    '#D5E6E5',
    'LINHA 9 - ESMERALDA',
    '#076D51',
    'LARANJA',
    '#E17D3F',
    'VERDE',
    '#7AC74B',
    'LINHA AZUL',
    '#6394F7',
    'LINHA VERDE',
    '#7AC74B',
    'LINHA LARANJA',
    '#E17D3F',
    'LINHA 1',
    '#d7191c',
    'LINHA 2',
    '#fec980',
    'LINHA 3',
    '#c7e8ad',
    'LINHA 4',
    '#2b83ba',
    'EXPANSÃO ASA NORTE',
    '#d7191c',
    'VLT RMBS',
    '#d7191c',
    'LINHA NORTE',
    '#d7191c',
    'LINHA LESTE',
    '#fec980',
    'LINHA SUL',
    '#c7e8ad',
    'LINHA OESTE',
    '#2b83ba',
    'LINHA SUL - VLT',
    '#c7e8ad',
    'LINHA OESTE - VLT',
    '#2b83ba',
    'LINHA CENTRO',
    '#d7191c',
    'LINHA CENTRO 1',
    '#fec980',
    'LINHA CENTRO 2',
    '#c7e8ad',
    'VLT PARANGABA-MUCURIPE',
    '#fec980',
    'VLT AEROPORTO',
    '#c7e8ad',
    'CBTU JOÃO PESSOA',
    '#d7191c',
    'AEROMÓVEL',
    '#d7191c',
    'VLT DO CARIRI',
    '#d7191c',
    'RAMAL BELFORD ROXO',
    '#d7191c',
    'RAMAL DEODORO',
    '#ea643f',
    'RAMAL GUAPIMINIM',
    '#fdae61',
    'RAMAL JAPERI',
    '#fed790',
    'RAMAL MANGABEIRAS',
    '#ffffbf',
    'RAMAL PARACAMBI',
    '#d5eeb2',
    'RAMAL SANTA CRUZ',
    '#abdda4',
    'RAMAL SARACURUNA',
    '#6bb0af',
    'RAMAL VILA INHOMIRIM',
    '#2b83ba',
    '#FF0000',
  ],
  'circle-radius': 15,
}

export const LayersData = [
  {
    name: 'view_ibge_explorer_renda_mensal_domiciliar',
    schema: 'ibge',
    style: rendaStyle,
    config: {
      tile: `${process.env.REACT_APP_MAP_VECTORTILE}/operation/intersect/{z}/{x}/{y}.pbf?`,
      minZoom: 0,
      maxZoom: 23,
      lineWidthMinPixels: 1,
      pickable: true,
      stroked: true,
      lineWidthScale: 1,
      id: 'renda_mensal_domiciliar_layer',
      renderSubLayers: (props) => {
        return [
          new GeoJsonLayer(props, {
            autoHighlight: true,
            pickable: true,
            stroked: true,
            highlightColor: [0, 200, 255, 128],
            getLineColor: () => [255, 255, 255],
            getFillColor: (f) => {
              return ColorMapboxToKepler(
                {
                  'fill-color': [
                    'interpolate',
                    ['linear'],
                    ['to-number', ['get', 'renda_mensal_domiciliar']],
                    0,
                    '#FF6666',
                    1000,
                    '#FFB266',
                    2500,
                    '#FFFF66',
                    5000,
                    '#B2FF66',
                    7500,
                    '#66ff66',
                    9000,
                    '#66ffff',
                    15000,
                    '#66b2ff',
                    20000,
                    '#6666ff',
                  ],
                  'fill-opacity': 0.8,
                },
                f.properties,
                'fill-color'
              )
            },
          }),
        ]
      },
    },
  },
  {
    name: 'view_explorer_apartamento_venda_',
    schema: 'nacional',
    style: precoVendaStyle,
    config: {
      tile: `${process.env.REACT_APP_MAP_VECTORTILE}/operation/intersect/{z}/{x}/{y}.pbf?`,
      minZoom: 0,
      maxZoom: 23,
      lineWidthMinPixels: 1,
      pickable: true,
      stroked: true,
      lineWidthScale: 1,
      id: 'apartamento_venda_layer',
      getLineColor: () => [255, 255, 255],
      getFillColor: (f) => {
        return ColorMapboxToKepler(precoVendaStyle, f.properties, 'fill-color')
      },
      renderSubLayers: (props) => {
        return [
          new GeoJsonLayer(props, {
            autoHighlight: true,
            pickable: true,
            stroked: true,
            radiusMinPixels: 6,
            radiusMaxPixels: 20,
            highlightColor: [0, 200, 255, 128],
            getPointRadius: props.getPointRadius || 10,
            updateTriggers: {
              lineColor: props.getLineColor,
              fillColor: props.getFillColor,
              getPointRadius: props.getPointRadius || 10,
            },
          }),
        ]
      },
    },
  },
  {
    name: 'trilhos_urbanos_trajetos',
    schema: 'nacional',
    style: trilhosTrajetosStyle,
    config: {
      tile: `${process.env.REACT_APP_MAP_VECTORTILE}/tile/trilhos_urbanos_trajetos/{z}/{x}/{y}.pbf?`,
      minZoom: 0,
      maxZoom: 23,
      lineWidthMinPixels: 1,
      pickable: true,
      stroked: true,
      lineWidthScale: 1,
      id: 'trilhos_urbanos_trajetos_layer',
      getLineColor: () => [255, 255, 255],
      getFillColor: (f) => {
        return ColorMapboxToKepler(trilhosTrajetosStyle, f.properties, 'line-color')
      },
      renderSubLayers: (props) => {
        return [
          new GeoJsonLayer(props, {
            autoHighlight: true,
            pickable: true,
            stroked: true,
            highlightColor: [0, 200, 255, 128],
            getLineColor: (f) => {
              return ColorMapboxToKepler(trilhosTrajetosStyle, f.properties, 'line-color')
            },
            getLineWidth: 7,
            lineWidthMinPixels: 7,
          }),
        ]
      },
    },
  },
  {
    name: 'trilhos_urbanos_estacoes',
    schema: 'nacional',
    style: trilhosEstacoesStyle,
    config: {
      tile: `${process.env.REACT_APP_MAP_VECTORTILE}/tile/trilhos_urbanos_estacoes/{z}/{x}/{y}.pbf?`,
      minZoom: 0,
      maxZoom: 23,
      lineWidthMinPixels: 1,
      pickable: true,
      stroked: true,
      lineWidthScale: 1,
      id: 'trilhos_urbanos_estacoes_layer',
      getLineColor: () => [255, 255, 255],
      getFillColor: (f) => {
        return ColorMapboxToKepler(trilhosEstacoesStyle, f.properties, 'line-color')
      },
      getPointRadius: 10,
      renderSubLayers: (props) => {
        return [
          new GeoJsonLayer(props, {
            autoHighlight: true,
            pickable: true,
            stroked: true,
            highlightColor: [0, 200, 255, 128],
            getLineColor: (f) => {
              return ColorMapboxToKepler(trilhosEstacoesStyle, f.properties, 'line-color')
            },
            getFillColor: (f) => {
              return ColorMapboxToKepler(trilhosEstacoesStyle, f.properties, 'fill-color')
            },
            getRadiusSize: () => {
              let value = GetPropert(trilhosEstacoesStyle, 'circle-radius')
              return value || 10
            },
            getPointRadius: 15,
            getLineWidth: 7,
            lineWidthMinPixels: 7,
          }),
        ]
      },
    },
  },
]
